<template>
  <div class="ag-grid-text-floating-filter">
    <input
      ref="input"
      v-model="value"
      class="ag-floating-filter-input"
      type="text"
      :title="value"
      @keydown.tab="apply"
      @blur="apply"
      @keydown.enter="apply">
  </div>
</template>

<script>
import Vue from 'vue'

/**
 * Floating filter for the text columns. Typing here goes on to hit the API, so the criteria are
 * applied when they are asked for - the button, or the enter key - rather than on a timer after the
 * last keystroke.
 */
export default Vue.extend({
  name: 'AgGridTextFloatingFilter',

  data () {
    return {
      value: ''
    }
  },

  methods: {
    /**
     * ag-grid IFloatingFilterComp: shows what the parent filter holds, which is what the rows on
     * screen were filtered by - including after this filter applied it
     * @param parentModel
     */
    onParentModelChanged (parentModel) {
      this.value = (parentModel && parentModel.filter) || ''
    },
    /**
     * Hands the typed criteria to the column's filter, which applies them at once
     */
    apply () {
      const value = (this.value || '').trim()
      this.params.parentFilterInstance(filterInstance => {
        // No text is the column asking for nothing, which clears it
        filterInstance.onFloatingFilterChanged('contains', value || null)
      })
    }
  }
})
</script>

<style scoped>
  .ag-grid-text-floating-filter {
    display: flex;
    align-items: center;
    width: 100%;
  }
  .ag-grid-text-floating-filter input {
    flex: 1;
    min-width: 0;
  }
  .apply-button {
    flex: none;
    margin-left: 2px;
    padding: 0 2px;
    border: none;
    background: transparent;
    cursor: pointer;
    line-height: 1;
  }
  .apply-button:hover .ag-icon {
    opacity: 1;
  }
  .apply-button .ag-icon {
    opacity: 0.6;
  }
</style>



// WEBPACK FOOTER //
// src/components/SigmaClientNew/AgGridTextFloatingFilter.vue